
// import * as db from '@/libs/db.js';
import { Phrase } from "./Phrase";

function diffDays(timeA, timeB) {
  return (timeA - timeB) / 1000 / 60 / 60 / 24;
}

export class Item {

  constructor(item) {
    this.history = [];

    this.id = item.id;
    this.sortIndex = item.sortIndex;
    this.disabled = item.disabled;
    this.studying = item.studying;
    this.placeholder = item.placeholder;
    this.properties = {
      english: {
        value: item.english,
        type: "text",
      },
      thai: {
        value: item.thai,
        type: "text",
      },
      note: {
        value: item.note,
        type: "text",
      }
    };

    this.phrase = new Phrase(this.properties.thai.value);
  }

  getSuccessDays() {
    var successDays = 0;
    for (let historyEntry of this.history) {
      if (this.doesSessionScorePass(historyEntry)) {
        successDays += 1;
      }
    }
    return successDays;
  }

  daysToNextReview() {
    var today = (new Date()).getTime();
    return diffDays(this.calculateNextReviewTime(), today);
  }

  itemReadyToReview() {
    return ((this.daysToNextReview()) <= 0.2);
  }

  calculateNextReviewTime() {
    var successes = 0;
    for (let historyEntry of this.history) {
      if (this.doesSessionScorePass(historyEntry)) {
        successes += 1;
      }
    }
    var lastReviewDate = this.history[this.history.length - 1].date;
    var dayInterval = Math.pow(successes, 1.5);
    // oo,o,,o,,,o,,,,o,,,,,o
    return lastReviewDate + dayInterval * (24 * 60 * 60 * 1000);
  }

  doesSessionScorePass(historyEntry) {
    return historyEntry.score >= 0.66;
  }

  async readyToLearn() {
    let complexity = await this.phrase.effectivePhraseComplexity();
    console.log(`Item complexity: ${complexity} \t ${this.properties.thai.value}`);
    return complexity <= 1;
  }

  async getComplexity() {
    return await this.phrase.effectivePhraseComplexity();
  }

}

export class ItemAdapter {

  static flatten(item) {
    return {
      id: item.id,
      disabled: item.disabled,
      studying: item.studying,
      placeholder: item.placeholder,
      thai: item.properties.thai.value,
      english: item.properties.english.value,
      note: item.properties.note.value,
      sortIndex: item.sortIndex,
    };
  }

  static inflate(item) {
    return new Item(item);
    // return {
    //   id: item.id,
    //   sortIndex: item.sortIndex,
    //   disabled: item.disabled,
    //   studying: item.studying,
    //   placeholder: item.placeholder,
    //   properties: {
    //     english: {
    //       value: item.english,
    //       type: "text",
    //     },
    //     thai: {
    //       value: item.thai,
    //       type: "text",
    //     },
    //     note: {
    //       value: item.note,
    //       type: "text",
    //     }
    //   },
    // };
  }

}